<template>
	<div class="category-list" @click.stop>
		<div class="category-list__top-panel">
			<div class="category-list__venue-name">{{ venueInfo.name }}</div>
			<button class="close-button" type="button" @click="closeSidebar" />
		</div>

		<div class="category-list__frame">
			<side-nav @nav-item-click="handleNavItemClick" />
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import SideNav from './SideNav'

export default {
	name: 'CategoryList',
	components: { SideNav },
	computed: {
		...mapState('venue', ['venueInfo']),
		...mapState('ui', ['isSidebarVisible', 'isDesktopDevice'])
	},
	methods: {
		...mapActions('ui', ['hideSidebar', 'lockScroll', 'unlockScroll']),

		handleNavItemClick(payload) {
			if (this.isSidebarVisible && !this.isDesktopDevice) {
				this.unlockScroll()
			}

			this.hideSidebar()
			this.$emit('nav-item-click', payload)
		},

		closeSidebar() {
			if (this.isSidebarVisible && !this.isDesktopDevice) {
				this.unlockScroll()
			}

			this.hideSidebar()
		}
	}
}
</script>

<style lang="scss">
@import './src/assets/styles/variables';
.category-list {
	position: relative;
	z-index: 600;
	width: 100%;
	height: 100%;
	margin-top: 3px;
	max-height: 403px;
	overflow: auto;
	border: 1px solid $border-color;
	border-radius: 6px;
	background-color: $background-popup;
	box-shadow: 0 2px 8px 0 rgba($black, 0.5);
	scrollbar-width: none;

	@media (max-width: 1024px) {
		padding: 8px 16px;
	}
	&::-webkit-scrollbar {
		width: 0;
		height: 0;
	}

	&__venue-name {
		font-weight: 700;
		font-size: 16px;
		margin-right: 15px;
		color: $white;
	}

	.close-button {
		position: relative;
		width: 38px;
		height: 38px;
		border-radius: 50%;
		top: 0;
		left: auto;
		z-index: 100;
		background: $background-box;
		border: 1px solid $border-color;
		transition: background-color 0.5s;

		&:before,
		&:after {
			left: 9px;
			top: 18px;
			width: 18px;
			border-width: 2px;
		}

		&:hover {
			opacity: 1;
			background: rgba($violet-grey, 0.8);
		}
	}

	&__top-panel {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 0 0 15px;
		padding-bottom: 15px;
		border-bottom: 1px solid $light-blue;

		@media (min-width: 1025px) {
			display: none;
		}
	}

	&__frame {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		@media (max-width: 1024px) {
			height: auto;
		}
	}
}
</style>
